"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SchemaError_1 = __importDefault(require("../Errors/SchemaError"));

var __1 = require("..");

var ValueSchema = /*#__PURE__*/function () {
  function ValueSchema(type) {
    _classCallCheck(this, ValueSchema);

    if (typeof __1.ParserTypes[type] === 'undefined') {
      throw new SchemaError_1.default("attribute type '".concat(type, "' not defined"));
    }

    this.parser = __1.ParserTypes[type];
  }

  _createClass(ValueSchema, [{
    key: "deserialize",
    value: function deserialize(state) {
      return this.parser.deserialize(state);
    }
  }, {
    key: "serialize",
    value: function serialize(value) {
      return this.parser.serialize(value);
    }
  }]);

  return ValueSchema;
}();

exports.default = ValueSchema;